/**
 * BillSave — 사용자PC(/u/orders) 오더 상세팝업의 계산서/결제 정보 저장·초기화.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 저장/리셋 전역함수를 이관했다(세금/다중발행 코어 슬라이스 D).
 *   - save_bill_info_new : 상세팝업 저장 버튼 → 폼값 수집 후 POST /u/ajax/order-tax/save-pay
 *   - reset_billset_new  : 초기화 버튼 → 다중/카드면 선택레이어, 단일이면 resetBillOne
 *   - resetBillOne       : 단일발행 오더 계산서/결제 초기화 → POST /u/ajax/order-tax/reset-bill
 *
 * 데드코드 정리(이관하지 않고 제거): reset_billset — 전 저장소 호출처 0 (reset_billset_new/resetBillOne 로 대체).
 *
 * 구조: 모듈 스코프 자유함수 + 얇은 브리지 클래스.
 *   - 내부 호출(reset_billset_new → resetBillOne)은 모듈 스코프로 해소.
 *   - 외부 전역은 bare 로 전역 해소:
 *       · get_number_only : 슬라이스 F(PaymentSettle) → window 브리지
 *       · exportContract  : BizForm → window 브리지
 *       · get_orders      : ListRender → window 브리지
 *       · popmultisel_checkCheck_new / popmultisel_checkCheck_paystatus_new / detailExpanseClose
 *         : 아직 u-order-list.js 잔류 전역함수(B·H 슬라이스)
 *       · swalert : 전역 유틸
 *   - 공유 상태 쓰기는 window.* 로: reLoadOrderNums / reLoadOrderNumsNo(list.js var 전역),
 *     onList / apply_after_reselect(선언없는 암시적 전역 — ListRender 도 window.onList 로 접근).
 *   - strict 대응: 원본의 미선언 할당 txtype → var 선언으로 수정.
 */
import Util from '../../../Common/Util';

/**
 * 사용자 PC 오더 상세내역 팝업에서 저장 버튼 누를때
 * @param SaveBtnTarget
 */
function save_bill_info_new(SaveBtnTarget){
    var pop_showOrderType = document.getElementById("pop_showOrderType").innerHTML;
    var payTypeSet = "싸인";
    if(  document.getElementById("isSaveOktogo") ){
        var isSaveOktogo = document.getElementById("isSaveOktogo").value;
        if( isSaveOktogo != "SOK"){
            if( isSaveOktogo == "multipleAlready"){
                Util.swalert("하나이상의 오더는 이미 다중 발행된 오더입니다.\n비고란을 확인해 주세요");
            }else{
                Util.swalert("상대거래는 대상이 한명 이상이면 저장할 수 없습니다.");
            }
            return;
        }
    }

    if(document.getElementById("baltype2").checked == true) payTypeSet  = "직수";
    if(document.getElementById("baltype5").checked == true) payTypeSet  = "카드";
    var n = 0;
    if( document.getElementById("billstatus_0").checked==true) n = 1;
    if( document.getElementById("billstatus_1").checked==true) n = 2;
    if( document.getElementById("billstatus_2").checked==true) n = 3;
    if( document.getElementById("billstatus_3").checked==true) n = 4;
    if( document.getElementById("billstatus_4").checked==true) n = 5;
    if( document.getElementById("billstatus_5").checked==true) n = 6;
    var saveTypeOrgin = n;
    var bal_gave_to_dirver = 0;
    if( document.getElementById("bal_gave_to_dirver2").checked == true ) bal_gave_to_dirver = 1;
    var bal_gave_when =document.getElementById("bal_gave_when").value;
    var bal_gave_who =document.getElementById("bal_gave_who").value;
    var bal_gave_price =get_number_only(document.getElementById("bal_gave_price").value);
    var bal_got_taxbill_from_soo = 0;
    if( document.getElementById("bal_got_taxbill_from_soo2").checked == true ) bal_got_taxbill_from_soo = 1;
    if( document.getElementById("bal_got_taxbill_from_soo9").checked == true ) bal_got_taxbill_from_soo = 9;
    var bal_gotbill_when =document.getElementById("bal_gotbill_when").value;
    var bal_gotbill_fromwhere =document.getElementById("bal_gotbill_fromwhere").value;
    var bal_gotbill_price =get_number_only(document.getElementById("bal_gotbill_price").value);
    var billdate =document.getElementById("billdate").value;
    var billTowho =document.getElementById("reciver_coname").innerHTML;
    var billPrice =get_number_only(document.getElementById("billPrice").value);
    var got_payed = 0;
    var got_payed_by = "";
    var got_payed_way = "";
    if( document.getElementById("payed_status2").checked == true ) got_payed = 1;//|| document.getElementById("payed_status3").checked == true
    if( got_payed == 1){
        if(document.getElementById("payed_status2").checked == true){
            if( document.getElementById("cheked_by_cash").checked == true) got_payed_way = "현금";
            if( document.getElementById("cheked_by_bank").checked == true) got_payed_way = "입금";
            got_payed_by = got_payed_way;
        }else if(document.getElementById("payed_status3").checked == true){
            got_payed_by = "카드";
            if( document.getElementById("cardpay_input").checked == true) got_payed_way = "입금";
        }
    }
    var paystae_date =document.getElementById("paystae_date").value;
    var paystae_where =document.getElementById("paystae_where").value;
    var paystate_payedtoto =get_number_only(document.getElementById("paystate_payedtoto").value);
    var paystate_worktotal =get_number_only(document.getElementById("paystate_worktotal").value);

    var popwinOrdernum = get_number_only(document.getElementById("popwinOrdernum").value);
    var sendData = {};
    var selnums = [];
    if( isNaN(popwinOrdernum)) popwinOrdernum = 0;
    if( popwinOrdernum < 1 ){ Util.swalert("오더 번호가 없습니다.");return;}

    if( document.getElementById("popmultisel_eachbox_0") ) {
        selnums = popmultisel_checkCheck_new(2);

    }else{

    }

    var bal_print_tax_refstr =  document.getElementById("bal_print_tax_refstr").value;
    var bill_tarCeo = document.getElementById("reciver_ceoname").innerHTML;
    var isRelated = 0;
    if( document.getElementById("multiCListBaljooTh") ) isRelated = 1;
    var refNo = parseInt(document.getElementById("baljoo_bizform_co_refno").value);
    if( isNaN(refNo)) refNo = 0;
    var payed_tome_co_refno = parseInt(document.getElementById("payed_tome_co_refno").value);
    if( isNaN(payed_tome_co_refno)) payed_tome_co_refno = 0;


    if( ( n == 2 || n == 5) && payed_tome_co_refno < 1 ){
        Util.swalert("공급자(나)를  선택해 주세요", function(){
            var obj = document.getElementById("SupplyerSelTd");
            obj.click();
        });

        return;
    }
    if( ( n == 2 || n == 5) && refNo < 1 ){
        var txtype = (n == 2) ? "하나만 발행" : "다중 발행";
        Util.swalert("세금계산서 발행을 [ " + txtype + " ]으로 설정하셨습니다.\n\n상대 공급받는 사업자를먼저 선택(입력)해 주세요", function(){
            var objTar = document.getElementById("targetBixInfoSel");
            if( objTar ) objTar.click();
        });

        return;
    }

    var regeditcoInfo_cotitle = document.getElementById("reciver_coname").innerHTML;

    SaveBtnTarget.innerHTML = "<img src='/img/loading_cir_80_fit.gif' style='height:30px'>";
    // pop_showOrderType
    sendData["popwinOrdernum"] = popwinOrdernum;
    sendData["silent_push"] = document.getElementById("silent_push") && document.getElementById("silent_push").checked ? 1 : 0;
    sendData["pop_showOrderType"] = pop_showOrderType;
    sendData["payTypeSet"] = payTypeSet;
    sendData["taxBillType"] = n;
    sendData["bal_gave_to_dirver"] = bal_gave_to_dirver ;
    sendData["bal_gave_when"] = bal_gave_when;
    sendData["bal_gave_who"] = bal_gave_who ;
    sendData["bal_gave_price"] = bal_gave_price ;

    sendData["bal_got_taxbill_from_soo"] = bal_got_taxbill_from_soo ;
    sendData["bal_gotbill_when"] = bal_gotbill_when ;
    sendData["bal_gotbill_fromwhere"] = bal_gotbill_fromwhere ;
    sendData["bal_gotbill_price"] = bal_gotbill_price ;

    sendData["billdate"] = billdate ;
    sendData["billTowho"] = billTowho ;
    sendData["billPrice"] = billPrice ;
    sendData["bill_ceo"] = bill_tarCeo ;

    sendData["got_payed"] = got_payed ;
    sendData["paystae_date"] = paystae_date ;
    sendData["paystae_where"] = paystae_where ;
    sendData["paystate_payedtoto"] = paystate_payedtoto ;
    sendData["paystate_worktotal"] = paystate_worktotal ;
    sendData["regeditcoInfo_cotitle"] = regeditcoInfo_cotitle ;


    sendData["payed_tome_co_refno"] = payed_tome_co_refno ;
    sendData["got_payed_by"] = got_payed_by ;
    sendData["got_payed_way"] = got_payed_way ;
    sendData["isRelated"] = isRelated ;
    sendData["refNo"] = refNo ;
    sendData["premulti_tax_refstr"] = bal_print_tax_refstr;

    sendData["selnums_apppay"] = popmultisel_checkCheck_paystatus_new();
    sendData["selnums"] = selnums.toString();

    var adr = "/u/ajax/order-tax/save-pay";
    $.ajax({type:"POST", url:adr, data:sendData, dataType:'json', success:function(data){
            // var goType = 9;
            var typetoautosave = parseInt( data.typetoautosave);
            var row_cnt = parseInt(data.row_cnt);
            var taxBillType = parseInt(data.taxBillType);
            let related_orders = data.orders.split(',');

            if( row_cnt == 0 && typetoautosave == 1 && taxBillType > 0 ){
                document.getElementById("current_billprintst").value = taxBillType;
                if( selnums.length > 1 ){
                    document.getElementById("bal_print_tax_refstr").value=selnums.toString();
                    document.getElementById("multibillnum").value=selnums[0];
                }
                exportContract('check');
            }
            window.reLoadOrderNums = [];
            if( selnums.length > 0 ){
                window.reLoadOrderNums = selnums;
                // goType = 91;
                window.onList=selnums;
                console.log( selnums );
            }else{
                window.reLoadOrderNums = [popwinOrdernum];
                window.onList= [popwinOrdernum];
            }
            //console.log(data);
            window.reLoadOrderNumsNo = 0;
            window.apply_after_reselect = 1;
            get_orders(related_orders);
            // Update_showingLists(1);
            SaveBtnTarget.innerHTML = "저장";
        }});
}

/**
 * 세금계산서 초기화 버튼 누를때
 * @param orderno 오더번호
 * @param tar 마우스클릭한 엘리먼트
 */
function reset_billset_new(orderno, tar){
    // 다발행 또는 카드
    if( document.getElementById("billstatus_4").checked==true || document.getElementById("billstatus_5").checked==true ){
        //reset_multiAll_billset_new(orderno);
        var obj = document.getElementById("resetBillselonediv");// 하나만 초기화, 일괄 초기화 선택 팝업레이어
        console.log( tar );
        var rt = tar.getBoundingClientRect();
        console.log( rt );
        obj.style.display="block";
        obj.style.left=parseInt(rt.left - 7) + "px";
        obj.style.top=parseInt(rt.bottom+3) + "px";
    }else{
        resetBillOne(orderno);
    }
}

/**
 * 세금계산서 초기화 처리 (단일발행된 오더에 대해서 처리)
 * @param orderno 오더번호
 */
function resetBillOne(orderno){
    var mTit = "선택한 오더의 계산서,결제 정보를 초기화 할까요?";
    Util.swalert([mTit,'question'],()=>{
        var adr = "/u/ajax/order-tax/reset-bill";
        var sendData = {"orderNum":orderno};
        $.ajax({type:"POST", url:adr, data:sendData, success:function(data){
                // TODO : 처리된 오더들에 대하여 리프레시 처리한다.
                if( data.result ){
                    detailExpanseClose(null);
                    window.reLoadOrderNums = [orderno];
                    window.reLoadOrderNumsNo = 0;
                }else{
                    Util.swalert("초기화 하지 못했습니다.");
                }
            }});
    },['네','아니오']);
}

export default class BillSave {
    save_bill_info_new = save_bill_info_new;
    reset_billset_new = reset_billset_new;
    resetBillOne = resetBillOne;
}
